import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5117ac50"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "CourierCard" }
const _hoisted_2 = { class: "CourierCard__header" }
const _hoisted_3 = { class: "flex items-center" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header__avatar" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-user" })
], -1))
const _hoisted_5 = { class: "header__contacts ml-3" }
const _hoisted_6 = { class: "contacts__name" }
const _hoisted_7 = { class: "contacts__phone" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-phone fa-xs fa-rotate-90 mr-2" }, null, -1))
const _hoisted_9 = { class: "CourierCard__content" }
const _hoisted_10 = {
  class: "flex flex-col",
  style: {"min-width":"130px"}
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-xs" }, "Сектор", -1))
const _hoisted_12 = { class: "text-sm font-semibold" }
const _hoisted_13 = { class: "flex flex-col" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-xs" }, "Загруженность авто", -1))
const _hoisted_15 = { class: "flex flex-col" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-xs" }, "Осталось доставок", -1))
const _hoisted_17 = { class: "text-sm font-semibold" }
const _hoisted_18 = { class: "flex flex-col" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-xs" }, "Осталось заборов", -1))
const _hoisted_20 = { class: "text-sm font-semibold" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_courier_workload = _resolveComponent("courier-workload")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.courier.fullName), 1),
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createElementVNode("span", null, _toDisplayString(_ctx.courier.phoneNumber), 1)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _hoisted_11,
        _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.getSectors), 1)
      ]),
      _createElementVNode("div", _hoisted_13, [
        _hoisted_14,
        (_ctx.courier.carOccupancy)
          ? (_openBlock(), _createBlock(_component_courier_workload, {
              key: 0,
              "car-occupancy": _ctx.courier.carOccupancy
            }, null, 8, ["car-occupancy"]))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createTextVNode(" - ")
            ], 64))
      ]),
      _createElementVNode("div", _hoisted_15, [
        _hoisted_16,
        _createElementVNode("p", _hoisted_17, _toDisplayString(_ctx.courier.leftDeliveriesCount), 1)
      ]),
      _createElementVNode("div", _hoisted_18, [
        _hoisted_19,
        _createElementVNode("p", _hoisted_20, _toDisplayString(_ctx.courier.leftTakesCount), 1)
      ])
    ])
  ]))
}